export default __webpack_public_path__ + "static/media/4.39e97e38.mp4";